<template>
<v-autocomplete
    v-model="localValue"
    :items="teams"
    :item-value="resolvedItemValue"
    :item-text="itemText"
    :label="label"
    :multiple="multiple"
    :chips="chips"
    :dense="dense"
    :outlined="outlined"
    :clearable="clearable"
    :rules="rules"
    :hint="String(localValue)"
    :persistent-hint="true"
  />

</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GroupSelect",
  props: {
    value: {
      type: [String, Number, Array],
      default: () => [],
    },
    clubId: {
      type: [String, Number],
      default: null,
    },
    itemValue: {
      // Accept string path or function
      type: [String, Function],
      default: "node.teamName",
    },
    itemText: {
      type: String,
      default: "node.teamName",
    },
    label: {
      type: String,
      default: "Select Group Name",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    competitiveFlag: {
      type: [Boolean, null],
      default: null, // null = show all, true = only competitive, false = only non-competitive
    },
  },
  computed: {
    ...mapGetters(["clubInfo"]),

    resolvedClubId() {
      return this.clubId || this.$route.params.club;
    },

    teams() {
      const edges = this.clubInfo && this.clubInfo.edges;
      if (!edges || !Array.isArray(edges)) return [];

      const club = edges.find(
        (item) => item.node && item.node.clubId == this.resolvedClubId
      );

      if (
        !club ||
        !club.node ||
        !club.node.team ||
        !Array.isArray(club.node.team.edges)
      ) {
        return [];
      }

      let teams = club.node.team.edges.slice();

      // Filter by competitiveFlag if set
      if (this.competitiveFlag !== null) {
        teams = teams.filter(
          (edge) => edge.node.competitiveFlag === this.competitiveFlag
        );
      }

      return teams.sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
    },

    resolvedItemValue() {
      if (typeof this.itemValue === "function") {
        return this.itemValue;
      }

      // Convert string path like 'node.teamId' into a value getter
      const path = this.itemValue.split(".");
      return (item) => {
        return path.reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : null),
          item
        );
      };
    },

    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
